<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-02 08:10:47
-->
<template>
    <div class="add-danwei">
        <el-form
            ref="ruleForm"
            :model="viewData"
            :rules="rules"
            label-width="100px"
        >
            <el-form-item label="标题" prop="title">
                <el-input v-model="viewData.title" />
            </el-form-item>
            <el-form-item label="跳转链接">
                <el-input v-model="viewData.url" />
            </el-form-item>
            <el-form-item label="图片">
                <image-upload ref="imageUpload" v-if="showUpload" :tipInfo="`上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M，建议尺寸100*100,请自己处理好宽高比例`" :image-list="imageDefaultList" @updateImg="onUpdateImg($event)"></image-upload>
            </el-form-item>
            <el-form-item label="排序">
                <el-input-number
                    style="width: 100px"
                    v-model="viewData.sort"
                    controls-position="right"
                    :min="0"
                ></el-input-number>
            </el-form-item>
            <el-form-item label="状态">
                <el-switch
                    v-model="viewData.status"
                    class="drawer-switch"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                />
            </el-form-item>
        </el-form>
        <div class="fix-fotter">
            <el-button style="min-width: 117px;background: #1067E0;font-size: 16px;" size="mini" type="primary" @click="tijiao('ruleForm')">提交</el-button>
        </div>
    </div>
</template>

<script>
import fetch from "@/api/console/FriendLink";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
import ImageUpload from '@/components/Upload/image'
export default {
    data() {
        return {
            showUpload:false,
            // 图片上传组件默认图片
            imageDefaultList:'',
            thumbList: [], // 图片暂存
            list:[],
            viewData: {
                id: "",
                title: "",
                url: '',
                thumb:'',
                status:1,
                sort:'',
            },
            rules: {
                title: [
                    {
                        required: true,
                        message: "请输入名称",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    components: {
        Pagination,
        ImageUpload,
    },
    created() {},
    methods: {
        /**
		 * @name: 图片更新
		 * @param {*} val
		 * @return {*}
		 * @desc: 
		 */		
		onUpdateImg(val){
			let thumbList = [];
			val.forEach((ele, idx) => {
                thumbList.push({
					url:ele.path,
					filetype:ele.filetype
				})
            });
			this.thumbList = thumbList;
			// console.log('图片更新==',this.thumbList);
		},
        /**
         * @name: 初始化列表
         * @param {*} obj
         * @return {*}
         * @desc:
         */
        initFun(obj) {
            $(".el-drawer__body").scrollTop(0)
            let that = this
            this.showUpload = false
            this.viewData = {
                id: "",
                title: "",
                url: '',
                thumb:'',
                status:1,
                sort:'',
            }
            this.imageDefaultList = ''
            this.thumbList = []
            this.showUpload = true
            
            if (obj.id && obj.type == 1) {
                // 编辑
                this.viewData.id = obj.id;
                fetch.detail({ id: obj.id }).then((res) => {
                    console.log(res)
                    if (res.code == 200) {
                        that.viewData = res.result
                        that.viewData.id = res.result.id;
                        
                        if(that.viewData.thumb) {
                            let imgList = []
                            let obj = {
								name: that.viewData.thumb,
								path:that.viewData.thumb,
								url: this.$publicData.imgUrl + that.viewData.thumb,
							}
							imgList.push(obj);
                            // 案件带的 回显图
                            that.imageDefaultList = JSON.stringify(imgList);
                        }
                    }
                });
            } else {
                // 新增
            }
        },
        /**
         * @name: 提交
         * @param {*} formName
         * @return {*}
         * @desc: 
         */		
         tijiao(formName) {
            let that = this
            console.log(this.thumbList[0])
            this.viewData.thumb = this.thumbList[0] ? this.thumbList[0].url : ''
            console.log(this.viewData)
            this.$refs[formName].validate(valid => {
                if (valid) {
					if(this.viewData.id){
						// 编辑
						fetch.edit(this.viewData).then(res=>{
                            that.resetForm()
							if(res.code == 200){
								that.$message.success(res.message);
								that.$emit('onUpdateDrawer', 1)
							}else{
								that.$message.error(res.message);
								that.$emit('onUpdateDrawer', -1)
							}
						})
					}else{
						// 新增
						fetch.create(this.viewData).then(res=>{
                            that.resetForm()
							if(res.code == 200){
								that.$message.success(res.message);
								that.$emit('onUpdateDrawer', 1)
							}else{
								that.$message.error(res.message);
								that.$emit('onUpdateDrawer', -1)
							}
						}) 
					}
                      
                } else {
                    // this.$message.warning(this.$t('form.verifyMsg'))
                }
            })
        },
        /**
         * @name: 清空form
         * @return {*}
         * @desc:
         */
        resetForm() {
            this.showUpload = false
            this.imageDefaultList = ''
            this.thumbList = []
            this.$refs["ruleForm"].resetFields();
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
